<template>
  <div class="quick-info">
    <div v-if="!isExclusive && entityType !== 'custom_workout'" class="free">Free</div>
    <div v-if="isExclusive && entityType !== 'custom_workout'" class="plus">Plus</div>
    <div v-if="isPlusFreeAccess" class="plus-free-access">Free Days</div>
    <div v-if="completeStatus" class="complete" aria-label="Complete">
      <i class="material-symbols-outlined" aria-hidden="true">check</i>
    </div>
    <div v-if="favoriteStatus" class="favorite" aria-label="Favorited">
      <i class="material-symbols-outlined fill" aria-hidden="true">favorite</i>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useFavoritesStore } from '@/stores/favorites'
import { useCompletesStore } from '@/stores/completes'

/** PROPS **/
const props = defineProps({
  isExclusive: {
    type: Boolean,
    default: false,
  },
  isPlusFreeAccess: {
    type: Boolean,
    default: false,
  },
  entityId: {
    type: Number,
    required: true,
  },
  entityType: {
    type: String,
    default: 'workout',
    validator: (val) => ['article', 'workout', 'custom_workout', 'wellness_video'].includes(val),
  },
})

/** STATE **/
const completesStore = useCompletesStore()
const favoritesStore = useFavoritesStore()

/** COMPUTED **/
const completeStatus = computed(() => {
  const completeCount = completesStore.userCompletes({
    schedulableType: props.entityType,
    schedulableId: props.entityId,
  })

  return !!completeCount
})

const favoriteStatus = computed(() => {
  return favoritesStore.isFavorite({
    favoritableType: props.entityType,
    favoritableId: props.entityId,
  })
})
</script>
